module.exports = __webpack_public_path__ + "fonts/Inter-700-latin-ext51.fad2a54.woff2";